<script lang="ts">
  interface Props {
    src: string;
    alt: string;
    class?: string;
    loading?: 'eager' | 'lazy';
  }

  let { src, alt, class: className = '', loading = 'lazy' }: Props = $props();
</script>

<figure class="phone {className}">
  <span class="phone__speaker" aria-hidden="true"></span>
  <span class="phone__screen">
    <img {src} {alt} {loading} decoding="async" />
  </span>
  <span class="phone__shine" aria-hidden="true"></span>
</figure>
